import {AbstractControl, FormControl, ValidatorFn} from '@angular/forms';

export class CustomValidators {
  static ageValidator(ageLimit) {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
      const today = new Date();
      const tyear = today.getFullYear();
      let tmonth = today.getMonth();
      const tday = today.getDay();
      const selctedDate = new Date(control.value);
      const syear = selctedDate.getFullYear();
      const smonth = selctedDate.getMonth();
      const sday = selctedDate.getDay();
      let age = tyear - syear;
      tmonth = tmonth + 1;
      if (tmonth < smonth) {
        age--;
      }

      if (smonth === tmonth && tday < sday) {
        age--;
      }
      if (age < ageLimit){
        return {' ageValidator ': true};
      }
      return null;
    };
  }
  static passwordConfirmation(c: AbstractControl): { invalid: boolean } {
    if (c.get('password').value !== c.get('confirmPasswordFormControl').value) {
      return {invalid: true};
    }
  }

  static therapistSpecializedAge(c: any): { invalid: boolean } {
    const professionalAreaDetailsArray = c.get('professionalExperience');
    let isEmpty = false;
    for (const professionalDetail of professionalAreaDetailsArray.controls) {
      if (professionalDetail.controls.isPrenatal.value || professionalDetail.controls.isBaby.value ||
        professionalDetail.controls.isToddler.value || professionalDetail.controls.isPreSchool.value ||
        professionalDetail.controls.isSchoolAged.value || professionalDetail.controls.isTeenager.value ||
        professionalDetail.controls.isYoungAdult.value)
      {
        isEmpty = false;
      }else{
        isEmpty = true;
        break;
      }    }
    if (isEmpty) {
      return {invalid: true};
    }
  }

}

